/* Variant redirect map - redirects old ?variant= URLs to new product pages */
(function() {
  var p = new URLSearchParams(window.location.search);
  var v = p.get("variant");
  if (!v) return;
  v = v.split("&")[0];
  var m = {
"52880705061130":"/products/lunette-de-soleil-gucci-gg1535s-noir-001",
"52844686835978":"/products/lunette-de-soleil-saint-laurent-slm740-noir-004",
"52880687235338":"/collections/lunette-de-soleil-balenciaga",
"52844732350730":"/products/lunette-de-soleil-gucci-gg1278s-dore-005",
"52880711418122":"/products/lunette-de-soleil-gucci-gg1680s-marron-ecaille-004",
"52880692740362":"/collections/lunette-de-soleil-gucci",
"52844685459722":"/products/lunette-de-soleil-prada-pr-b53s-dore-5ak09z",
"52844709282058":"/products/lunette-de-soleil-gucci-gg1550sk-marron-ecaille-002",
"52844734939402":"/products/lunette-de-soleil-saint-laurent-sl567-noir-001",
"52846816624906":"/products/lunette-de-soleil-ray-ban-meta-gen-2-rw4012-noir-601-1m-2",
"52844696338698":"/products/lunette-de-soleil-gucci-gg1618s-noir-001",
"52844715147530":"/products/lunette-de-soleil-prada-pr-14ws-ecaille-de-tortue-caramel-poudre-01r0a6",
"44534195716362":"/products/lunette-de-soleil-retrosuperfuture-noir-alva-001",
"52880691659018":"/collections/lunette-de-soleil-balenciaga",
"52844717244682":"/products/lunette-de-soleil-gucci-gg1421s-noir-001",
"52844715278602":"/products/lunette-de-soleil-prada-pr-17ws-nude-vyj6x1",
"52844734546186":"/products/lunette-de-soleil-saint-laurent-sl557-noir-001",
"52844679299338":"/collections/lunette-de-soleil-bottega-veneta",
"52844695224586":"/products/lunette-de-soleil-lily-sl213",
"52844711149834":"/products/lunette-de-soleil-saint-laurent-sl312m-dore-006",
"52880719773962":"/collections/lunette-de-soleil-gucci",
"52844734775562":"/collections/lunette-de-soleil-saint-laurent",
"52844692832522":"/products/lunette-de-soleil-gucci-gg1084s-marron-003",
"52844683723018":"/products/lunette-de-soleil-ray-ban-rb3016-noir-sur-or-w0365",
"52846816592138":"/products/lunette-de-soleil-ray-ban-meta-gen-2-rw4012-noir-601-71",
"52846816133386":"/collections/ray-ban-meta",
"52844735627530":"/products/lunette-de-soleil-saint-laurent-sl596-marron-ecaille-claire-003",
"52880725967114":"/collections/lunette-de-soleil-prada",
"52880704930058":"/collections/lunette-de-soleil-saint-laurent",
"52844677366026":"/products/lunette-de-soleil-prada-pr-b16s-noir-16k08z",
"52844697878794":"/products/lunette-de-soleil-gucci-gg1517s-marron-ecaille-003",
"52844680216842":"/products/lunette-de-soleil-gucci-gg1535s-noir-001",
"52844713836810":"/products/lunette-de-soleil-prada-pr-a02s-noir-16k08z",
"52844678119690":"/products/lunette-de-soleil-ray-ban-rb3719-dore-001-31",
"52844731531530":"/products/lunette-de-soleil-bottega-veneta-noir-bv1219s-002",
"52865182138634":"/products/lunette-de-soleil-ray-ban-rb2289-noir-901-31-2",
"52844716392714":"/products/lunette-de-soleil-saint-laurent-sl654-marron-ecaille-003",
"52844711608586":"/products/lunette-de-soleil-saint-laurent-slm40-noir-001",
"52844734611722":"/products/lunette-de-soleil-saint-laurent-sl557-marron-ecaille-002",
"52844686672138":"/products/lunette-de-soleil-bottega-veneta-bv1322s-marron-ecaille-002",
"52844690768138":"/products/lunette-de-soleil-bottega-veneta-bv1242s-marron-ecaille-002",
"52880725508362":"/collections/lunette-de-soleil-prada",
"52844693225738":"/collections/lunette-de-soleil-gucci",
"44534174384394":"/products/lunette-de-soleil-retrosuperfuture-bordeaux-knives-002",
"52844716917002":"/products/lunette-de-soleil-bottega-veneta-bv1249s-noir-001",
"52846816100618":"/collections/ray-ban-meta",
"52844734480650":"/products/lunette-de-soleil-saint-laurent-sl550-noir-001",
"52844710396170":"/products/lunette-de-soleil-prada-pr-65zs-or-pale-zvn09t",
"52844678512906":"/products/lunette-de-soleil-ray-ban-rb4455-noir-667781",
"52844682903818":"/products/lunette-de-soleil-ray-ban-rb3025-dore-001-51",
"52844736971018":"/products/lunette-de-soleil-prada-pr-17ws-marron-ecaille-2au8c1",
"52844688539914":"/products/lunette-de-soleil-gucci-gg1680s-noir-001",
"52844681232650":"/products/lunette-de-soleil-saint-laurent-sl815romy-marron-ecaille-002",
"52844694274314":"/products/lunette-de-soleil-saint-laurent-sl507-noir-001",
"52851083149578":"/collections/ray-ban-meta",
"52844734054666":"/products/lunette-de-soleil-saint-laurent-slm94-noir-001-2",
"52844716458250":"/products/lunette-de-soleil-saint-laurent-sl634-noir-001",
"52844684509450":"/products/lunette-de-soleil-ray-ban-rb0840s-marron-ecaille-claire-954-33",
"52846815969546":"/collections/ray-ban-meta",
"52844683690250":"/products/lunette-de-soleil-ray-ban-rb4454-noir-667731",
"52844678381834":"/products/lunette-de-soleil-ray-ban-rb4456-noir-667781",
"52844681658634":"/products/lunette-de-soleil-saint-laurent-slm146-marron-ecaille-002",
"52844720619786":"/products/lunette-de-soleil-prada-pr-27zs-marron-ecaille-19j09z",
"52844684706058":"/products/lunette-de-soleil-ray-ban-rb0316s-marron-ecaille-990-31",
"52844685754634":"/products/lunette-de-soleil-prada-pr-b05s-noir-ecaille-3890a7",
"52844698206474":"/products/lunette-de-soleil-balenciaga-bb0331sk-noir-001",
"52880690807050":"/products/lunette-de-soleil-prada-pr-17ws-noir-1ab5s0",
"52844710297866":"/products/lunette-de-soleil-prada-pr-65zs-or-pale-zvn20i",
"52844682739978":"/products/lunette-de-soleil-ray-ban-rb2289-noir-6826j5",
"52844721111306":"/collections/lunette-de-soleil-retrosuperfuture",
"52880708469002":"/products/lunette-de-soleil-ray-ban-rb3347-dore-001-51-2",
"52844696994058":"/products/lunette-de-soleil-prada-pr-a59-noir-1ab60g",
"52844678480138":"/products/lunette-de-soleil-ray-ban-rb4455-marron-ecaille-135987",
"52844697420042":"/collections/lunette-de-soleil-tom-ford",
"52844687458570":"/products/lunette-de-soleil-gucci-gg1703s-dore-004",
"52844682674442":"/products/lunette-de-soleil-balenciaga-bb0369sk-noir-001",
"52844731662602":"/products/lunette-de-soleil-bottega-veneta-dore-bv1223s-001",
"52880687366410":"/collections/lunette-de-soleil-bottega-veneta",
"52844721930506":"/products/lunette-de-soleil-saint-laurent-sl560-noir-001",
"52880723542282":"/products/lunette-de-soleil-balenciaga-bb0321s-noir-002",
"52844737462538":"/products/lunette-de-soleil-tom-ford-noir-tf1044-001",
"52844733399306":"/products/lunette-de-soleil-saint-laurent-sl276-marron-ecaille-claire-042",
"52844733890826":"/products/lunette-de-soleil-saint-laurent-sl28-beige-006",
"52846816002314":"/collections/lunette-de-soleil-gucci",
"52844685852938":"/products/lunette-de-soleil-gucci-gg0998s-noir-001",
"52844736020746":"/products/lunette-de-soleil-gucci-gg1342s-noir-001",
"52844735103242":"/products/lunette-de-soleil-saint-laurent-sl572-noir-001",
"52844689981706":"/products/lunette-de-soleil-bottega-veneta-bv1101s-marron-ecaille-002",
"52844690538762":"/products/lunette-de-soleil-bottega-veneta-bv1005s-noir-001",
"52844685558026":"/products/lunette-de-soleil-prada-pr-b06s-noir-16k08z",
"52844689817866":"/products/lunette-de-soleil-prada-pr-14ys-noir-1ab5s0",
"52842069098762":"/products/lunette-de-soleil-saint-laurent-sl815romy-noir-001",
"52842069623050":"/products/lunette-de-soleil-saint-laurent-sl815romy-marron-ecaille-002",
"52842069360906":"/products/lunette-de-soleil-saint-laurent-sl815-marron-ecaille-009",
"52844719407370":"/products/lunette-de-soleil-prada-pr-13z-noir-1ab5s0",
"52844677300490":"/products/lunette-de-soleil-prada-pr-b16s-noir-16k08z",
"52868584603914":"/products/lunette-de-soleil-ray-ban-meta-gen-2-rw4012-noir-601-71",
"52844703645962":"/products/lunette-de-soleil-gucci-gg1547s-noir-001",
"52844692996362":"/products/lunette-de-soleil-gucci-gg1449s-noir-001",
"52880687825162":"/collections/lunette-de-soleil-saint-laurent",
"52844685164810":"/products/lunette-de-soleil-gucci-gg1730s-marron-ecaille-002",
"52844713214218":"/products/lunette-de-soleil-gucci-gg1425s-noir-001",
"52844733038858":"/products/lunette-de-soleil-gucci-gg1314s-nude-005",
"52880727277834":"/collections/lunette-de-soleil-gucci",
"52844732088586":"/products/lunette-de-soleil-gucci-marron-gg1261s-001",
"52844689686794":"/products/lunette-de-soleil-gucci-gg1661s-noir-001",
"52844687589642":"/products/lunette-de-soleil-gucci-gg1680s-marron-ecaille-004",
"52844732809482":"/collections/lunette-de-soleil-gucci",
"52844689719562":"/products/lunette-de-soleil-gucci-gg1661s-marron-ecaille-002",
"52844731859210":"/products/lunette-de-soleil-gucci-gg0956s-noir-001",
"52844693127434":"/products/lunette-de-soleil-gucci-gg1449s-marron-ecaille-002",
"52844690637066":"/products/lunette-de-soleil-bottega-veneta-bv1005s-marron-ecaille-002",
"52844735070474":"/products/lunette-de-soleil-saint-laurent-sl572-noir-001",
"52844677202186":"/products/lunette-de-soleil-prada-pr-b15s-noir-16k731",
"52844709576970":"/products/lunette-de-soleil-gucci-gg1531s-noir-001",
"52844718719242":"/products/lunette-de-soleil-prada-pr-06y-noir-09q5s0",
"52844680315146":"/products/lunette-de-soleil-gucci-gg2015s-noir-001",
"52844732743946":"/products/lunette-de-soleil-gucci-vert-gg1278s-004",
"52844712788234":"/collections/lunette-de-soleil-tom-ford",
"52846817018122":"/products/lunette-de-soleil-ray-ban-meta-gen-2-rw4012-noir-601-71",
"52880719839498":"/collections/lunette-de-soleil-gucci",
"52844712886538":"/products/lunette-de-soleil-gucci-marron-ecaille-gg1408s-001",
"52844712165642":"/products/lunette-de-soleil-gucci-gg1300s-marron-ecaille-003",
"52844709511434":"/products/lunette-de-soleil-gucci-gg1531s-noir-001",
"52844732875018":"/products/lunette-de-soleil-gucci-gg0516s-noir-001",
"52844690964746":"/products/lunette-de-soleil-balenciaga-bb0132s-marron-ecaille-002",
"52844682117386":"/products/lunette-de-soleil-saint-laurent-slm146-noir-001",
"52844683165962":"/products/lunette-de-soleil-ray-ban-rb3347-dore-001-2",
"52880722100490":"/products/lunette-de-soleil-gucci-gg1502s-noir-001",
"52844686999818":"/products/lunette-de-soleil-saint-laurent-slm94-marron-ecaille-003",
"52844694307082":"/products/lunette-de-soleil-gucci-gg1553s-noir-001",
"52844688933130":"/products/lunette-de-soleil-saint-laurent-sl28-marron-050",
"52844729794826":"/products/lunette-de-soleil-balenciaga-bb0096s-noir-001",
"52844691685642":"/collections/lunette-de-soleil-balenciaga",
"52844698599690":"/products/lunette-de-soleil-balenciaga-bb0324s-noir-002",
"52844696076554":"/products/lunette-de-soleil-saint-laurent-sl759-marron-ecaille-002",
"52844694536458":"/products/lunette-de-soleil-saint-laurent-slm130-noir-001",
"52844689228042":"/products/lunette-de-soleil-saint-laurent-sl751-noir-001",
"52844711870730":"/products/lunette-de-soleil-gucci-gg1221s-dore-001",
"52844711903498":"/products/lunette-de-soleil-gucci-gg1221s-dore-002",
"52844736643338":"/collections/lunette-de-soleil-tom-ford",
"52844692635914":"/products/lunette-de-soleil-gucci-gg0208s-noir-001",
"52844685328650":"/products/lunette-de-soleil-gucci-gg1829sk-marron-ecaille-002",
"52844678250762":"/products/lunette-de-soleil-ray-ban-rb3719-dore-001-31",
"52844686180618":"/products/lunette-de-soleil-prada-pr-rb03s-noir-1ab5s0",
"52844680151306":"/products/lunette-de-soleil-gucci-gg1535s-marron-ecaille-002",
"52844684968202":"/products/lunette-de-soleil-gucci-gg1714s-marron-ecaille-002",
"52844685918474":"/collections/lunette-de-soleil-gucci",
"52844735922442":"/products/lunette-de-soleil-retrosuperfuture-bordeaux-knives-002",
"52844696109322":"/products/lunette-de-soleil-gucci-gg1660s-noir-001",
"52844688802058":"/products/lunette-de-soleil-saint-laurent-slm130-marron-ecaille-004",
"52844737724682":"/collections/lunette-de-soleil-tom-ford",
"52844720685322":"/products/lunette-de-soleil-prada-pr-27zs-noir-16k08z",
"52844716654858":"/products/lunette-de-soleil-saint-laurent-sl609-marron-ecaille-003",
"52880727212298":"/collections/lunette-de-soleil-gucci",
"52844732252426":"/products/lunette-de-soleil-gucci-gg1325s-noir-001",
"52844718784778":"/products/lunette-de-soleil-prada-pr-06ys-noir-marbre-05w06o",
"52844714393866":"/products/lunette-de-soleil-prada-pr-a05s-noir-16k08z",
"52844679627018":"/products/lunette-de-soleil-ray-ban-rb3547-dore-001-51",
"52844737921290":"/collections/lunette-de-soleil-tom-ford",
"52844683395338":"/products/lunette-de-soleil-ray-ban-rb3347-dore-001-51-2",
"52844695093514":"/collections/lunette-de-soleil-gucci",
"52844718293258":"/products/lunette-de-soleil-balenciaga-bb0157s-noir-001",
"52844697747722":"/products/lunette-de-soleil-gucci-gg1502s-noir-001",
"52844712034570":"/products/lunette-de-soleil-gucci-gg1221s-dore-002",
"52844720193802":"/products/lunette-de-soleil-prada-pr-17ws-gris-12r30b",
"52844721209610":"/products/lunette-de-soleil-retrosuperfuture-noir-tutto-002",
  };
  if (m[v]) window.location.replace(m[v]);
})();
